import axios from "axios";
import { Pinia } from "pinia";
import { useAuthStore } from "@/plugins/pinia";

export class PlatformUserInfoService {
    private authStore: ReturnType<typeof useAuthStore>;

    constructor(pinia: Pinia) {
        this.authStore = useAuthStore(pinia);
    }

    public getUserAuthorizationData(): AuthorizationData {
        // Null assertion ok because it should have been loaded at startup
        return this.authStore.authorizationData!;
    }

    public async loadAuthorizationDataFromServer(): Promise<void> {
        try {
            const data = await axios.get("/api/v1/sessions/authorizationdata");

            this.authStore.storeAuthorizationData(data.data);
        } catch (e) {
            console.log("Failed to load authorization data from server");
        }
    }
}

export interface AuthorizationData {
    userID: string;
    roles: Role[];
    supplierIDs: string[];
    type: UserType;
    allSuppliersVisible: boolean;
}

export enum Role {
    Admin,
    BusinessLineAdmin,
    SupplierManager,
    ScorecardOversight,
}

export enum UserType {
    Internal,
    Supplier,
}
